import { apiClient } from '@/api/client'

/**
 * Una volta per sessione, dice al backend se il browser si dichiara pilotato da un programma o senza finestra
 * (sessioni automatiche, V1437: le vede solo il super-admin). Sono indizi, non prove: il backend li tratta come
 * dato non fidato e accetta una sola chiamata per sessione. Nessun effetto per chi usa il portale: niente
 * messaggi, e un errore viene ignorato.
 */
let inviatoPer: string | null = null

/** @param sessione chi è entrato: dopo un logout e un nuovo accesso senza ricaricare, si rimanda. */
export function inviaSegnaliBrowser(sessione: string): void {
  if (inviatoPer === sessione) return
  inviatoPer = sessione
  try {
    const nav = navigator as Navigator & { userAgentData?: { brands?: { brand: string }[] } }
    const indizi: string[] = []
    const automatizzato = nav.webdriver === true
    if (automatizzato) indizi.push('webdriver')
    if (/HeadlessChrome/i.test(nav.userAgent)) indizi.push('user agent headless')
    if (nav.userAgentData?.brands?.some((b) => /headless/i.test(b.brand))) indizi.push('brand headless')
    if (window.outerWidth === 0 && window.outerHeight === 0) indizi.push('finestra di dimensione zero')
    const senzaFinestra = indizi.some((i) => i !== 'webdriver')
    if (!automatizzato && !senzaFinestra) return
    void apiClient
      .post('/api/v2/sicurezza/segnali-browser', {
        automatizzato,
        senzaFinestra,
        dettaglio: indizi.join(', ').slice(0, 200),
      })
      .catch(() => {})
  } catch {
    // nessun segnale: il portale funziona come sempre
  }
}
